import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout_dispatch } from '../../../redux/auth/auth.actions';
import { LogoutOutlined } from '@mui/icons-material';
import UserGuideButton from '../../UserGuide/components/UserGuideButton';

const TopBar = () => {
    const dispatch = useDispatch();
    const currentDate = new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000); // Update time every second

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const formattedTime = currentTime.toLocaleTimeString('en-US', {
        hour12: false,
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit'
    });

    return (
        <div className="bg-[#f6f7fa] border-b border-gray-300">
            <div className="mx-auto px-2 py-2">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <img
                            className="h-10"
                            alt="Logo"
                            src="/ripik-logo.png"
                        />
                    </div>
                    <div className='flex flex-col items-center gap-2'>
                        <h1 className="text-xl font-semibold">Sample Receiver Dashboard</h1>
                        <p className="text-sm">Please enter the {" "}
                            <span className='font-bold'>
                                date & time
                            </span>
                            {" "} at which you received the sample </p>
                    </div>
                    <div className="flex items-center">
                        <p className="text-sm mr-2">{currentDate}</p>
                        <p className="text-sm mr-2">{formattedTime}</p>
                    </div>
                    <UserGuideButton />
                    <Box className={`justify-start my-2 flex items-center gap-3 border border-red-500 rounded p-2 hover:text-red-500 hover:cursor-pointer`}
                        onClick={() => {
                            dispatch(logout_dispatch());
                        }}
                    >
                        <LogoutOutlined />
                        {
                            <Typography>Logout</Typography>
                        }
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default TopBar;
